module.exports = __webpack_public_path__ + "static/img/irole.a53c1c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/yjyx/irole.png
// module id = ABVd
// module chunks = 7